const STORAGE_KEY = 'tesoreria_caja_movimientos_demo_v1';
const CAJAS_KEY = 'tesoreria_cajas_demo_v1';

const defaultCajas = [
  { id: 'caja-1', nombre: 'Caja Principal' },
  { id: 'caja-2', nombre: 'Caja Sucursal Centro' },
  { id: 'caja-3', nombre: 'Caja Sucursal Norte' },
];

const defaultMovimientos = [
  {
    id: 'mov-001',
    fecha: '2024-11-12',
    cajaId: 'caja-1',
    cajaNombre: 'Caja Principal',
    tipo: 'Ingreso',
    concepto: 'Aporte inicial',
    importe: 125000,
    referencia: 'ING-0001',
    observaciones: 'Movimiento demo inicial.',
  },
  {
    id: 'mov-002',
    fecha: '2024-11-13',
    cajaId: 'caja-2',
    cajaNombre: 'Caja Sucursal Centro',
    tipo: 'Egreso',
    concepto: 'Pago de viáticos',
    importe: 32000,
    referencia: 'EGR-0004',
    observaciones: 'Gasto de movilidad.',
  },
];

const readStorage = (key, fallback) => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  const raw = localStorage.getItem(key);
  if (!raw) {
    return fallback;
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
};

const writeStorage = (key, value) => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
};

const ensureSeedData = () => {
  const storedCajas = readStorage(CAJAS_KEY, null);
  if (!Array.isArray(storedCajas) || storedCajas.length === 0) {
    writeStorage(CAJAS_KEY, defaultCajas);
  }

  const storedMovimientos = readStorage(STORAGE_KEY, null);
  if (!Array.isArray(storedMovimientos) || storedMovimientos.length === 0) {
    writeStorage(STORAGE_KEY, defaultMovimientos);
  }
};

const buildId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `mov-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const normalizeDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date;
};

// TODO: Reemplazar este service por llamadas reales a la API de Tesorería.
export const listCajas = async () => {
  ensureSeedData();
  return readStorage(CAJAS_KEY, defaultCajas);
};

// TODO: Reemplazar este service por llamadas reales a la API de Tesorería.
export const listMovimientos = async (filters = {}) => {
  ensureSeedData();
  const movimientos = readStorage(STORAGE_KEY, defaultMovimientos);

  const { fechaDesde, fechaHasta, tipo, cajaId } = filters;
  const fromDate = normalizeDate(fechaDesde);
  const toDate = normalizeDate(fechaHasta);

  const filtered = movimientos.filter((movimiento) => {
    if (tipo && movimiento.tipo !== tipo) {
      return false;
    }
    if (cajaId && movimiento.cajaId !== cajaId) {
      return false;
    }
    const movimientoDate = normalizeDate(movimiento.fecha);
    if (fromDate && movimientoDate && movimientoDate < fromDate) {
      return false;
    }
    if (toDate && movimientoDate && movimientoDate > toDate) {
      return false;
    }
    return true;
  });

  return filtered.sort((a, b) => (b.fecha || '').localeCompare(a.fecha || ''));
};

// TODO: Reemplazar este service por llamadas reales a la API de Tesorería.
export const createMovimiento = async (payload) => {
  ensureSeedData();
  const movimientos = readStorage(STORAGE_KEY, defaultMovimientos);
  const cajas = readStorage(CAJAS_KEY, defaultCajas);
  const caja = cajas.find((item) => item.id === payload.cajaId);

  const movimiento = {
    id: buildId(),
    fecha: payload.fecha,
    cajaId: payload.cajaId,
    cajaNombre: caja?.nombre ?? 'Caja sin nombre',
    tipo: payload.tipo,
    concepto: payload.concepto,
    importe: Number(payload.importe),
    referencia: payload.referencia || '',
    observaciones: payload.observaciones || '',
  };

  const updated = [movimiento, ...movimientos];
  writeStorage(STORAGE_KEY, updated);

  return movimiento;
};
